module.exports = false;



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 2